import { IonInfiniteScroll, IonInfiniteScrollContent } from '@ionic/react';
import { ChannelListItem } from './ChannelListItem';

interface ChannelResult {
  id: string;
  name: string;
  description?: string | null;
  viewerIsOwner?: boolean;
  viewerIsFollowing?: boolean;
}

interface ChannelSearchResultsProps {
  channels: ChannelResult[];
  hasMore: boolean;
  onLoadMore: (event: CustomEvent<void>) => void;
}

// Presentational list of channel search results with infinite scroll.
export const ChannelSearchResults = ({
  channels,
  hasMore,
  onLoadMore,
}: ChannelSearchResultsProps) => {
  return (
    <>
      <div className="pb-2">
        {channels.map((channel) => (
          <ChannelListItem
            key={channel.id}
            id={channel.id}
            name={channel.name}
            description={channel.description}
            viewerIsOwner={channel.viewerIsOwner}
            viewerIsFollowing={channel.viewerIsFollowing}
          />
        ))}
      </div>

      {hasMore && (
        <IonInfiniteScroll onIonInfinite={onLoadMore} threshold="100px">
          <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Cargando más..." />
        </IonInfiniteScroll>
      )}
    </>
  );
};
